import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import LogoMarquee from '../components/ui/LogoMarquee'
import ShimmerButton from '../components/ui/ShimmerButton'
import GrantaEarthLogo from '../components/ui/GrantaEarthLogo'

export default function Partnerships() {
  return (
    <>
      <Helmet>
        <title>Partnerships | GrantaEarth Co.</title>
        <meta name="description" content="We welcome aligned partners across mining offtake, fuel supply, and commodity trade structures." />
      </Helmet>

      <section className="bg-gradient-to-b from-off-white to-white section-padding">
        <div className="container-custom">
          <div className="text-center mb-8">
            <GrantaEarthLogo size="lg" className="mx-auto mb-6" />
          </div>
          
          <h1 className="text-3xl md:text-5xl font-extrabold text-center">Partnerships</h1>
          <p className="mt-4 text-center text-gray-700 max-w-3xl mx-auto">
            We collaborate with investors, offtakers, and suppliers who value predictability, documentation, and transparent trade.
          </p>

          <div className="mt-10">
            <LogoMarquee 
              speed="slow"
              pauseOnHover={true}
              logos={[
                { name: "Mining Partners", url: "#" },
                { name: "Energy Companies", url: "#" },
                { name: "Trade Associates", url: "#" },
                { name: "Financial Partners", url: "#" },
                { name: "Logistics Partners", url: "#" },
                { name: "Technology Partners", url: "#" },
                { name: "Regional Suppliers", url: "#" },
                { name: "Global Buyers", url: "#" },
              ]}
            />
          </div>

          <div className="mt-12 text-center">
            <Link to="/contact">
              <ShimmerButton>Contact Trade Desk</ShimmerButton>
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
